import {
  OnCancellationPoliciesClick,
  OnClickProductCard,
  OnProductCardTabClick,
  OnProductSlideshowNavigation,
  OnReadMoreClick,
  OnSeeOffersButtonClick,
  OnTechnicalSheetTabSelection
} from './product.types'

export const CLICK_PRODUCT_CARD = 'CLICK_PRODUCT_CARD'
export const CLICK_ON_PRODUCT_CARD_TAB = 'CLICK_ON_PRODUCT_CARD_TAB'
export const PRODUCT_SLIDESHOW_NAVIGATION = 'PRODUCT_SLIDESHOW_NAVIGATION'
export const READ_MORE_CLICK = 'READ_MORE_CLICK'
export const SEE_OFFERS_BUTTON_CLICK = 'SEE_OFFERS_BUTTON_CLICK'
export const TECHNICAL_SHEET_TAB_SELECTION = 'TECHNICAL_SHEET_TAB_SELECTION'
export const ON_CANCELLATION_POLICIES_CLICK = 'ON_CANCELLATION_POLICIES_CLICK'

export const onClickProductCard: OnClickProductCard = (
  productKey,
  productPosition,
  productCardZone,
  tabs,
  tags
) => ({
  payload: {
    productCardZone,
    productKey,
    productPosition,
    tabs,
    tags
  },
  type: CLICK_PRODUCT_CARD
})

export const onProductCardTabClick: OnProductCardTabClick = (tabType) => ({
  payload: {
    tabType
  },
  type: CLICK_ON_PRODUCT_CARD_TAB
})

export const onProductSlideshowNavigation: OnProductSlideshowNavigation = (
  activeSlideIndex,
  totalSlidesCount
) => ({
  payload: {
    activeSlideIndex,
    totalSlidesCount
  },
  type: PRODUCT_SLIDESHOW_NAVIGATION
})

export const onReadMoreClick: OnReadMoreClick = (
  productKey,
  productPosition
) => ({
  payload: { productKey, productPosition },
  type: READ_MORE_CLICK
})

export const onSeeOffersButtonClick: OnSeeOffersButtonClick = () => ({
  type: SEE_OFFERS_BUTTON_CLICK
})

export const onTechnicalSheetTabSelection: OnTechnicalSheetTabSelection = (title) => ({
  payload: { title },
  type: TECHNICAL_SHEET_TAB_SELECTION
})

export const onCancellationPoliciesClick: OnCancellationPoliciesClick = () => ({
  type: ON_CANCELLATION_POLICIES_CLICK
})
